import { styles } from '../../vehicle-card.styles';
import { myAdsTestId } from '../../../../utils';
import type { TCardMetricsConfig } from '../../vehicle-card.types';

const EyeIcon = () => (
	<svg className={styles.metricIcon} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fillRule="evenodd" clipRule="evenodd" d="M9.3335 7.33333C8.96483 7.33333 8.66683 7.632 8.66683 8C8.66683 8.36733 8.36816 8.66667 8.00016 8.66667C7.63216 8.66667 7.3335 8.36733 7.3335 8C7.3335 7.63267 7.63216 7.33333 8.00016 7.33333C8.36883 7.33333 8.66683 7.03467 8.66683 6.66667C8.66683 6.29867 8.36883 6 8.00016 6C6.8975 6 6.00016 6.89733 6.00016 8C6.00016 9.10267 6.8975 10 8.00016 10C9.10283 10 10.0002 9.10267 10.0002 8C10.0002 7.632 9.70216 7.33333 9.3335 7.33333ZM8.00016 10.6667C5.6495 10.6667 3.72083 9.34067 2.78883 8C3.72083 6.65933 5.6495 5.33333 8.00016 5.33333C10.3508 5.33333 12.2795 6.65933 13.2115 8C12.2795 9.34067 10.3508 10.6667 8.00016 10.6667ZM14.5788 7.66867C13.5328 5.84267 11.0935 4 8.00016 4C4.90683 4 2.4675 5.84267 1.4215 7.66867C1.30416 7.874 1.30416 8.126 1.4215 8.33133C2.4675 10.1573 4.9075 12 8.00016 12C11.0928 12 13.5328 10.1573 14.5788 8.33133C14.6962 8.126 14.6962 7.874 14.5788 7.66867Z" fill="#2E2E3A"/>
	</svg>
);

const MessageIcon = () => (
	<svg className={styles.metricIcon} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fillRule="evenodd" clipRule="evenodd" d="M4 3.33333C3.63267 3.33333 3.33333 3.63267 3.33333 4V9.724L4.19533 8.862C4.32 8.73667 4.49 8.66667 4.66667 8.66667H10.0013C10.3693 8.66667 10.668 8.36733 10.668 8V4C10.668 3.63267 10.3693 3.33333 10.0013 3.33333H4ZM2.66667 12C2.58067 12 2.494 11.9833 2.41133 11.9493C2.16267 11.846 2 11.6027 2 11.3333V4C2 2.89733 2.89733 2 4 2H10.0013C11.1047 2 12.0013 2.89733 12.0013 4V8C12.0013 9.10267 11.1047 10 10.0013 10H4.94267L3.138 11.8047C3.01067 11.932 2.84 12 2.66667 12Z" fill="#2E2E3A"/>
		<path fillRule="evenodd" clipRule="evenodd" d="M13.3333 14C13.16 14 12.9893 13.932 12.862 13.8047L11.0573 12H6.00133C5.63333 12 5.33467 11.7013 5.33467 11.3333C5.33467 10.9653 5.63333 10.6667 6.00133 10.6667H11.3333C11.51 10.6667 11.6793 10.7367 11.8047 10.862L12.6667 11.724V6.668C12.6667 6.3 12.9653 6.00133 13.3333 6.00133C13.7013 6.00133 14 6.3 14 6.668V13.3333C14 13.6027 13.8373 13.846 13.5887 13.9493C13.506 13.9833 13.4193 14 13.3333 14Z" fill="#2E2E3A"/>
	</svg>
);

const CalendarIcon = () => (
	<svg className={styles.metricIcon} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fillRule="evenodd" clipRule="evenodd" d="M3.33333 12.6667H12.6667V7.99999H3.33333V12.6667ZM3.33333 5.33332H3.51867C3.75 5.72999 4.176 5.99999 4.66667 5.99999H5.33333C5.824 5.99999 6.25 5.72999 6.48133 5.33332H9.51867C9.75 5.72999 10.176 5.99999 10.6667 5.99999H11.3333C11.824 5.99999 12.25 5.72999 12.4813 5.33332H12.6667V6.66666H3.33333V5.33332ZM4.66667 3.99999H5.33333L5.33133 4.66666H4.66667V3.99999ZM10.6667 3.99999H11.3333L11.3313 4.66666H10.6667V3.99999ZM13.3333 3.99999H12.6667C12.6667 3.26466 12.0687 2.66666 11.3333 2.66666H10.6667C9.93133 2.66666 9.33333 3.26466 9.33333 3.99999H6.66667C6.66667 3.26466 6.06867 2.66666 5.33333 2.66666H4.66667C3.93133 2.66666 3.33333 3.26466 3.33333 3.99999H2.66667C2.298 3.99999 2 4.29866 2 4.66666V13.3333C2 13.7013 2.298 14 2.66667 14H13.3333C13.702 14 14 13.7013 14 13.3333V4.66666C14 4.29866 13.702 3.99999 13.3333 3.99999Z" fill="#2E2E3A"/>
	</svg>
);

const formatDate = (dateString: string): string => {
	const date = new Date(dateString);
	return date.toLocaleDateString('pt-BR', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric'
	});
};

const CardMetrics = ({ adId, views, interestedCount, createdAt }: TCardMetricsConfig) => {
	const hasAnyMetric = views !== undefined || interestedCount !== undefined || createdAt !== undefined;

	if (!hasAnyMetric) {
		return null;
	}

	return (
		<div className={styles.metricsContainer} data-testid={myAdsTestId.cardMetrics(adId)}>
			{views !== undefined && (
				<div className={styles.metricItem}>
					<EyeIcon />
					<span>{views} visitas</span>
				</div>
			)}
			{interestedCount !== undefined && (
				<div className={styles.metricItem}>
					<MessageIcon />
					<span>{interestedCount} interessados</span>
				</div>
			)}
			{createdAt && (
				<div className={styles.metricItem}>
					<CalendarIcon />
					<span>Criado em {formatDate(createdAt)}</span>
				</div>
			)}
		</div>
	);
};

CardMetrics.displayName = 'CardMetrics';

export { CardMetrics };
